import getBlobDuration from "get-blob-duration";

export const getBlobURL = (blob, file) => {
  let url = null;
  try {
    if (blob && blob.size > 0) {
      const objectToUse = file || blob;
      url = URL.createObjectURL(objectToUse);
    }
  } catch (err) {
    console.error("Error creating blob URL:", err);
  }
  return url;
};

export const getFile = (blob, buffer, fileName) => {
  let file = null;
  try {
    // file = new File([blob], "noname.mp3", { type: blob.type });
    const audioBlob = new Blob([blob], { type: "audio/mp3" });
    file = new File([audioBlob], fileName, {
      type: "audio/mp3",
      lastModified: Date.now(),
    });
  } catch (err) {
    file = new File([buffer], fileName, {
      type: "audio/mp3",
      lastModified: Date.now(),
    });
  }
  return file;
};

export const getDuration = async (blob) => {
  let duration = 0;
  duration = await getBlobDuration(blob)
    .then((d) => {
      return d;
    })
    .catch(async (e) => {
      console.log(e);
      return 0;
    });
  return duration;
};
